module.exports = __webpack_public_path__ + "img/discuss-screen-dark-es.420b4785.png";